import { render, staticRenderFns } from "./oasisPatientDetails.vue?vue&type=template&id=e73d8896&scoped=true&"
import script from "./oasisPatientDetails.vue?vue&type=script&lang=js&"
export * from "./oasisPatientDetails.vue?vue&type=script&lang=js&"
import style0 from "./oasisPatientDetails.vue?vue&type=style&index=0&id=e73d8896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73d8896",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/build/repo/components/Loading.vue').default})
